import { Controller } from "stimulus";

// The "Display Signature Images" switch on the edit share link page: its value is posted only
// when the user has changed it. A
// link that follows its list keeps following it through edits of other fields, a toggle back to
// the starting state posts nothing, and while the link's list has a four-eyes change to Display
// Signatures awaiting approval, a switch left at On is not re-posted (that would be refused at
// apply time and block every other edit) while a switch moved to Off is.
//
// hanamiUjs reads the form with FormData at the form's own submit event, which bubbles from the
// form before reaching the document; a listener on the form runs first and disabled fields are
// left out of FormData. The request is built within that same dispatch, so the fields are turned
// back on in the next task: a refused save leaves the switch usable.
export default class extends Controller {
  static targets = ["field"];

  // The starting state is the page as served (defaultChecked), not the box's state now: a browser
  // that restored the box before Stimulus connected would otherwise make a visible choice look
  // unchanged and drop it.
  connect() {
    this.initial = this.fieldTarget.defaultChecked;
    this.form = this.element.closest("form");
    this.strip = this.strip.bind(this);

    if (this.form) this.form.addEventListener("submit", this.strip);
  }

  disconnect() {
    if (this.form) this.form.removeEventListener("submit", this.strip);
  }

  strip() {
    if (this.fieldTarget.checked !== this.initial) return;

    this.setDisabled(true);
    setTimeout(() => this.setDisabled(false), 0);
  }

  setDisabled(disabled) {
    this.inputs.forEach((input) => {
      input.disabled = disabled;
    });
  }

  // The form builder's hidden "0" and the checkbox share the name.
  get inputs() {
    return this.element.querySelectorAll(`input[name='${this.fieldTarget.name}']`);
  }
}
